import React, { FC, ReactNode } from 'react';
import { Button } from '@mui/material';

import { CloseIcon } from 'src/shared/components/icons';

export interface ModalHeaderProps {
  title: ReactNode;
  onClose: () => void | Promise<void>;
  message?: string;
  startIcon?: ReactNode;
  className?: string;
}

export const ModalHeader: FC<ModalHeaderProps> = ({ title, message, startIcon, className = '', onClose }) => {
  return (
    <div className={`d-flex justify-content-between align-items-baseline me-4 ${className}`}>
      <div className="d-flex">
        {startIcon}
        <div>
          <h4>{title}</h4>
          {message && <p className="text-muted fw-400">{message}</p>}
        </div>
      </div>
      <Button
        size="small"
        className="modal-close-btn"
        variant="contained"
        color="info"
        startIcon={<CloseIcon />}
        onClick={onClose}
        classes={{ startIcon: 'm-0' }}
      />
    </div>
  );
};
